





























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import EditorWithFile from "@/components/EditorWithFile.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import {
  CourseCreate as ICourseCreate,
  Course as ICourse
} from "@/api-v2/course/models";
import {
  Category as ICategory,
  CategoryList as ICategoryList,
  EmployeesList2 as IEmployeesList2,
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import categories, { CategoriesListParams } from "@/getinfo-api/categories";
import { AxiosError } from "axios";
import { getCurrentCompanyId } from "@/plugins/roles";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";

@Component({
  components: {
    CSingleSelect,
    EditorWithFile,
    CBlock,
    CField
  }
})
export default class CourseFormV2 extends Vue {
  @Prop() course!: ICourse;
  @Prop() companyId!: string;
  description: string = "";
  categoryList: Array<ICategory> = [];
  responsibleList!: IEmployeesList2;
  foo: boolean = false;
  employees: EmployeesListClass = new EmployeesListClass(
    {
      id: this.selectedCompany,
      roles: ["content_manager"],
      limit: 900
    },
    this.selectedCompany,
    this.course.responsibleId
  );

  courseForm: ICourseCreate = {
    title: "",
    locale: "en-EN" ?? "",
    description: "",
    objectives: [],
    categoryId: "",
    companyId: this.companyId,
    responsibleId: "",
    enabled: true
  };

  data() {
    return {
      responsibleList: undefined
    };
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  getAllCategory() {
    let params: CategoriesListParams = {
      companyId: this.selectedCompany,
      limit: 600
    };
    categories(params)
      .then((res: { data: ICategoryList }) => {
        this.categoryList = res.data.items;
        if (res.data) {
          this.courseForm.categoryId = !this.course
            ? res.data.items[0].id
            : this.course.category?.id;
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  @Watch("courseForm", { immediate: true, deep: true })
  checkCourseForm() {
    this.$emit("input", this.courseForm);
  }

  created() {
    this.getAllCategory();
    if (this.course) {
      this.courseForm = this.course;
      this.courseForm.enabled = this.course?.enabled ?? true;
    }
  }
}
